import { Routes, Route } from 'react-router-dom';
import ModelDrawer from '../../ModelDrawer';
import { navigateToScene, SceneProps, SceneSideDrawerRoute } from '../scene-utils';
import StopePanelPage from '../../StopePanelPage';
import { Model } from '../../hooks/useModelState';
import { removeIsolateFilters, resetIsolateStage } from './StopeSelectedSceneActions';

const setSelectedNodeOnModel = (model: Model, nodeId: string) => {
  const node = model.nodes[nodeId];
  if (node) {
    model.setSelectedNode(node);
  }
};

const stopeSelectedSceneSideDrawerRoutes = (
  model: Model,
  _path: string,
  _baseUrl: string,
  currentDrawerState: boolean,
  setDrawerStateCallback: (isOpen: boolean) => void,
  editNodesCallback: (isOpen: boolean) => void,
  setAddStopeMode: (mode: boolean) => void,
): SceneSideDrawerRoute[] => [
    {
      path: '*',
      isOpen: currentDrawerState,
      setIsOpen: setDrawerStateCallback,
      component: model && (
        <StopePanelPage
          key={`${model.selectedNode?.id ?? 'none'}::${model.selectedStope?.data?.stopeId ?? 'none'}`}
          model={model}
          onStopeEdit={({ nodeId, stopeId }) => {
            setSelectedNodeOnModel(model, nodeId);
            const stope = Object.values(model.stopes).flat().find((s) => s?.data?.stopeId === stopeId);
            if (stope) {
              model.setSelectedStope(stope);
            }
            setAddStopeMode(false);
            editNodesCallback(true);
          }}
          onAddStope={({ nodeId }) => {
            setSelectedNodeOnModel(model, nodeId);
            setAddStopeMode(true);
            editNodesCallback(true);
          }}
        />
      ),

      backNavText: 'Stopes', // msgid; ModelDrawer translates it
    },
  ];

const SideDrawerContent = ({ props, model }: { props: SceneProps; model: Model }) => {
  const handleBack = () => {
    model.unsetSelectedStope();
    removeIsolateFilters(model);
    resetIsolateStage();
    navigateToScene('DEFAULT', { model, context: props.context });
  };

  const routes = stopeSelectedSceneSideDrawerRoutes(
    model,
    props.meta.path,
    props.meta.url,
    props.context.state.drawerOpen,
    props.context.actions.setDrawerOpen,
    props.context.actions.editNodes,
    props.context.actions.setAddStopeMode,
  );

  return (
    <Routes>
      {routes.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          element={(
            <ModelDrawer
              isOpen={route.isOpen}
              setIsOpen={route.setIsOpen}
              backNavText={route.backNavText as string}
              onBack={handleBack}
            >
              {route.component}
            </ModelDrawer>
          )}
        />
      ))}
    </Routes>
  );
};

const sideDrawerContent = (props: SceneProps, model: Model): JSX.Element => (
  <SideDrawerContent props={props} model={model} />
);

export default sideDrawerContent;
